export const JAPAN_JOB_LEVEL_OPTIONS = [
    'Individual Contributor',
    'Manager',
    'Director / Sr',
    'VP',
    'C-Level',
    'Other',
] as const;
